import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { Button } from '../atoms/button';
import { Heading, SubHeading } from './style';
import variables from '../atoms/variables.json';
import RentalWarrentyPopup from './rentalWarrentyPopup';
import { LineSeperator } from '../atoms/backComponent/styles';
import { Text, View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { tenantActions } from '../../redux/tenant.actions';

const RentalWarrenty = (props) => {
  useEffect(() => {}, []);

  const dispatch = useDispatch();
  const warranty = props.warranty;
  const flowId = props.flowId;
  const propertyId = props.obxPropertyId;
  const [modalData, setModalData] = useState('');
  const [checkedValue, setCheckedValue] = useState('Buy-Yourself');
  const [showSuccessModal, setSuccessModal] = React.useState({ status: false, type: null });

  console.log('warrantywarrantywarrantywarranty', warranty);
  useEffect(() => {
    console.log(warranty);
    if (warranty && warranty?.baught_or_commission) {
      let checkvalue = warranty?.baught_or_commission == 'commission' ? 'Earn-Commission' : 'Buy-Yourself';
      setCheckedValue(checkvalue);
    }
  }, [warranty]);

  const handleChange = (event) => {
    setCheckedValue(event);
  };

  const buyWarranty = (data) => {
    console.log("data",data)
    setSuccessModal({ status: false, type: null })
    dispatch(tenantActions.buyRentalWarranty(flowId, data.type != 'buy', data));
  };
  const CardBox = ({ children }) => (
    <View
      style={{
        backgroundColor: '#fff',
        borderRadius: 12,
        padding: 20,
        marginBottom: '5%',
        width: '100%',
        shadowColor: '#000',
        shadowOpacity: 0.1,
        shadowOffset: { width: 0, height: 2 },
        shadowRadius: 8,
        elevation: 4,
      }}
    >
      {children}
    </View>
  );
  
  const initialRentalWarranty = () => {
    return (
      <View style={{ padding: 16 }}>
        <CardBox>
          <View style={{ flexDirection: 'column', marginTop: 10, marginBottom: 20 }}>
            <SubHeading>
              Hubita has teamed up with FCC Paragon to bring marketing leading rental warranty, often referred to as
              rent guarantee product and services to you.
            </SubHeading>
            <SubHeading>
              Once you have completed your tenant referencing, rental warranty option will appear below.
            </SubHeading>
            <SubHeading>
              However if no options are displayed, you may call FCC Paragon directly on the number below.
            </SubHeading>
            <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
              <View style={{ flex: 0.5, alignItems: 'flex-end', paddingRight: 10 }}>
                <SubHeading>For Information contact:</SubHeading>
              </View>
              <View style={{ flex: 0.5, flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                <SubHeading style={{ color: '#6D08C0' }}>02392 315105</SubHeading>
                <TouchableOpacity onPress={() => copyToClipboard('02392 315105')}>
                  <Text style={{ color: '#6D08C0', fontWeight: 'bold' }}>Copy</Text>
                </TouchableOpacity>
              </View>
            </View>
            <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
              <View style={{ flex: 0.5, alignItems: 'flex-end', paddingRight: 10 }}>
                <SubHeading>Quote REF:</SubHeading>
              </View>
              <View style={{ flex: 0.5, flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                <SubHeading style={{ color: '#6D08C0' }}>OBX HS</SubHeading>
                <TouchableOpacity onPress={() => copyToClipboard('OBX HS')}>
                  <Text style={{ color: '#6D08C0', fontWeight: 'bold' }}>Copy</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </CardBox>
      </View>
    )
  };

  const checkWarrantyAvailable = () => {
    // dispatch(tenantActions.checkWarrantyAvailable(flowId));
  };

  const warrantyAvailable = () => {
    return (
      <div>
        {warranty?.baught_or_commission == null ? (
          <div>
            <CardBox hasShadow={true} hasBorderRadius={true} style={{ marginBottom: 8 }}>
              <div
                style={{
                  display: 'flex',
                  marginTop: 10,
                  marginBottom: 20,
                  flexDirection: 'column',
                }}
              >
                <SubHeading>This Tenancy has qualified for Rental Warranty..</SubHeading>
                <SubHeading marginTop={6}> 
                  Hubita has Teamed up with FCC Paragon to provide the best in class rental warranty.
                </SubHeading>
                <SubHeading marginTop={6}> You have two options.</SubHeading>
               
                  <SubHeading marginTop={6}>Buy yourself</SubHeading>
                  <SubHeading marginTop={6}>
                    You can buy your warranty directly from FCC via your openbrix account at a very competitive price.
                  </SubHeading>
           
               
              </div>
              <SubHeading marginTop={6}>Which option would you like to review?</SubHeading>
            </CardBox>
          </div>
        ) : null}
          <CardBox hasShadow={true} hasBorderRadius={true} style={{ marginBottom: 8}}>
            <div style={{ display: 'flex', marginTop: 10, marginBottom: 20, flexDirection: 'column' }}>
              <SubHeading>Buy Yourself</SubHeading>
              <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                <SubHeading marginTop={6}>Warranty Available:</SubHeading>
                <SubHeading marginTop={6}>{warranty?.name}</SubHeading>
                <Button
                  type="custom"
                  title={'Warranty Price:  ' + '  £' + warranty?.price.toFixed(2) + ''}
                  color={'black'}
                  style={{
                    backgroundColor: variables.lightgrey,
                    alignSelf: 'left',
                    marginBottom: 15,
                    width: 148,
                  }}
                />
              </div>
              <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 10 }}>
                {warranty?.status == 'warranty_available' ? (
                  <Button
                    type="custom"
                    onClick={() => {
                      setSuccessModal({ status: true, type: 'buy' });
                    }}
                    title={'Buy Now'}
                    color={'white'}
                    style={{ backgroundColor: variables.navyblue, alignSelf: 'left', marginBottom: 15 }}
                  />
                ) : null}

                {warranty?.status == 'pending' ? (
                  <Button
                    type="custom"
                    title={'Pending'}
                    color={'white'}
                    disabled={true}
                    style={{ backgroundColor: variables.yellow, alignSelf: 'left', marginBottom: 15 }}
                  />
                ) : null}
              </div>
              {warranty?.terms_url ? (
                <div style={{ display: 'flex', width: '100%', marginTop: 10, justifyContent: 'space-between' }}>
                  <CardBox
                    padding={'7px'}
                    style={{
                      width: '50%',
                      backgroundColor: variables.lightGreen,
                      border: 'solid 1px ' + variables.darkgreen,
                      borderRadius: 20,
                      marginBottom:1
                    }}
                    hasShadow={true}
                    hasBorderRadius={true}
                  >
                    <div style={{ justifyContent: 'space-between', display: 'flex', flex: 1, alignItems: 'center' }}>
                      <div style={{ fontSize: '14px' }}>Rental Warranty Terms</div>
                      <div style={{ display: 'flex', flexDirection: 'row', marginRight: 3 }}>
                        <span
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            window.open(warranty?.terms_url, '_blank');
                          }}
                        >
                          <div style={{ fontSize: '14px', fontWeight: 500, color: variables.purple1 }}>View</div>
                        </span>
                      </div>
                    </div>
                  </CardBox>
                </div>
              ) : null}
              {warranty?.waranty_schedule ? (
                <div style={{ display: 'flex', width: '100%', marginTop: '4%', justifyContent: 'space-between' }}>
                  <CardBox
                    padding={'7px'}
                    style={{
                      width: '50%',
                      backgroundColor: variables.lightpink,
                      border: 'solid 1px ' + variables.darkpink,
                      borderRadius: 20,
                      marginBottom:1
                    }}
                    hasShadow={true}
                    hasBorderRadius={true}
                  >
                    <div style={{ justifyContent: 'space-between', display: 'flex', flex: 1, alignItems: 'center' }}>
                      <div style={{ fontSize: '14px' }}>Rental Warranty Schedule</div>
                      <div style={{ display: 'flex', flexDirection: 'row', marginRight: 3 }}>
                        <span
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            window.open(warranty?.waranty_schedule, '_blank');
                          }}
                        >
                          <div style={{ fontSize: '14px', fontWeight: 500, color: variables.purple1 }}>View</div>
                        </span>
                      </div>
                    </div>
                  </CardBox>
                </div>
              ) : null}
            </div>
          </CardBox>
      </div>
    );
  };

  const warrantyNotAvailable = () => {
    return (
      <div>
        <CardBox hasShadow={true} hasBorderRadius={true} style={{ marginBottom: 8 }}>
          <div
            style={{
              display: 'flex',
              marginTop: 10,
              marginBottom: 20,
              flexDirection: 'column',
            }}
          >
            <SubHeading>This Tenancy does not qualify for rental warranty</SubHeading>
            <SubHeading>
              If you wish to have get more information on this please contact FCC on the details below.
            </SubHeading>
            <div style={{ display: 'flex', width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  flex: 0.5,
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  paddingRight: 20,
                }}
              >
                <SubHeading>For Information contact:</SubHeading>
              </div>
              <div
                style={{
                  display: 'flex',
                  flex: 0.5,
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  paddingLeft: 20,
                }}
              >
                <SubHeading style={{ color: '#6D08C0' }}>02392 315105</SubHeading>
              </div>
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  flex: 0.5,
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  paddingRight: 20,
                }}
              >
                <SubHeading>Quote REF:</SubHeading>
              </div>
              <div
                style={{
                  display: 'flex',
                  flex: 0.5,
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  paddingLeft: 20,
                }}
              >
                <SubHeading style={{ color: '#6D08C0' }}>OBX NW</SubHeading>
              </div>
            </div>
          </div>
        </CardBox>
      </div>
    );
  };

  const checkApiRequired = () => {
    return (
      <CardBox hasShadow={true} hasBorderRadius={true} style={{ marginBottom: 8 }}>
        <div
          style={{
            display: 'flex',
            marginTop: 10,
            marginBottom: 20,
            flexDirection: 'column',
          }}
        >
          <SubHeading>This tenancy MAY be qualify for a warranty.</SubHeading>
          <SubHeading>Would you like us to check to see?</SubHeading>

          <div style={{ display: 'flex', width: '100%' }}>
            {warranty.status == 'check_requested' ? (
              <div
                style={{
                  display: 'flex',
                  flex: 0.5,
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingRight: 20,
                }}
              >
                <Button
                  style={{
                    backgroundColor: variables.yellow,
                    color: 'black',
                    borderRadius: 5,
                  }}
                  type="solid"
                  noClick="noClick"
                  title={'Pending'}
                />
              </div>
            ) : null}
            {warranty.status == 'check_api_required' ? (
              <div
                style={{
                  display: 'flex',
                  flex: 0.5,
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingLeft: 20,
                }}
              >
                <Button
                  type="custom"
                  onClick={() => {
                    checkWarrantyAvailable();
                  }}
                  title={'check'}
                  color={'white'}
                  style={{ backgroundColor: variables.navyblue, alignSelf: 'left', marginBottom: 15 }}
                />
              </div>
            ) : null}
          </div>
        </div>
      </CardBox>
    );
  };

  console.log("warranty",warranty)
  return (
    <>
      <LineSeperator />

      <Heading style={{ marginTop: 20 }}>Rental Warranty</Heading>
      {warranty == null ? initialRentalWarranty() : null}

      {warranty &&
      (warranty.status == 'warranty_available' ||
        warranty.status == 'pending' ||
        warranty.status == 'warranty_schedule' ||
        warranty.status == 'sold')
        ? warrantyAvailable()
        : null}

      {warranty && warranty.status == 'warranty_not_available' ? warrantyNotAvailable() : null}

      {warranty && (warranty.status == 'check_api_required' || warranty.status == 'check_requested')
        ? checkApiRequired()
        : null}

      <RentalWarrentyPopup
        visible={showSuccessModal?.status}
        data={warranty}
        propertyId={propertyId}
        type={showSuccessModal.type}
        heading={showSuccessModal.type == 'buy' ? 'Buy Warranty' : 'Earn Commission'}
        subHeading={[
          `Thank you for choosing to buy your rental warranty.`,
          `Below are all the details reagrding the warranty you are about to buy.`,
          'Information Sharing',
          'Please note we will be sending the following information to FCC Paragon,',
        ]}
        onCancelPress={() => setSuccessModal(false)}
        onOkPress={(data) => {
          buyWarranty(data);
        }}
      />
    </>
  );
};

export default RentalWarrenty;
